const initialState = {

    //RV Details
    loadingRVDetails: false,
    RVDetails: {},
    RVDetailsError: '',

    //Companies LiST
    loadingRVCompaniesList: false,
    RVCompaniesList: [],
    RVCompaniesListError: '',

    //Invoice LiST
    loadingRVInvoiceList: false,
    RVInvoiceList: [],
    RVInvoiceListError: '',

    //Branch master LiST
    loadingBranchMasterList: false,
    BranchMasterList: [],
    BranchMasterListError: '',

    //Cash book LiST
    loadingCashBookList: false,
    CashBookList: [],
    CashBookListError: '',

    //Cost center LiST
    loadingCostCenterList: false,
    CostCenterList: [],
    CostCenterListError: '',


    //committed bank list
    loadingCommittedBankList: false,
    CommittedBankList: [],
    CommittedBankListError: '',


    
    //RV List
    loadingReceiptVoucherList: true,
    ReceiptVoucherList: [],
    ReceiptVoucherListError: '',
    ReceiptVoucherListCurrentPage: 0,
    ReceiptVoucherListTotalPage: 0,
    ReceiptVoucherListTotalData: 0


}

const ReceiptVoucherReducer = (state = initialState, action) => {
    switch (action.type) {


        //RV Details//
        case 'FIND_RECEIPT_VOUCHER_DETAILS_REQUEST':
            return {
                ...state,
                loadingRVDetails: true,
                RVDetails: {},
                RVDetailsError: '',
            };
        case 'FIND_RECEIPT_VOUCHER_DETAILS_SUCCESS':
            return {
                ...state,
                loadingRVDetails: false,
                RVDetails: action.payload.data,

            };
        case 'FIND_RECEIPT_VOUCHER_DETAILS_FAILURE':
            return {
                ...state,
                loadingRVDetails: false,
                RVDetailsError: action.payload,
            };
        //RV Details//

        //Companies LiST//
        case 'FIND_COMPANIES_LIST_REQUEST':
            return {
                ...state,
                loadingRVCompaniesList: true,
                RVCompaniesList: [],
                RVCompaniesListError: '',
            };
        case 'FIND_COMPANIES_LIST_SUCCESS':
            return {
                ...state,
                loadingRVCompaniesList: false,
                RVCompaniesList: action.payload.data,

            };
        case 'FIND_COMPANIES_LIST_FAILURE':
            return {
                ...state,
                loadingRVCompaniesList: false,
                RVCompaniesListError: action.payload,
            };
        //Companies LiST//
        //Invoice LiST//
        case 'FIND_RV_INVOICE_LIST_REQUEST':
            return {
                ...state,
                loadingRVInvoiceList: true,
                RVInvoiceList: [],
                RVInvoiceListError: '',
            };
        case 'FIND_RV_INVOICE_LIST_SUCCESS':
            return {
                ...state,
                loadingRVInvoiceList: false,
                RVInvoiceList: action.payload.data,

            };
        case 'FIND_RV_INVOICE_LIST_FAILURE':
            return {
                ...state,
                loadingRVInvoiceList: false,
                RVInvoiceListError: action.payload,
            };
        //Invoice LiST//
        //Branch Master LiST//
        case 'FIND_BRANCH_MASTER_LIST_REQUEST':
            return {
                ...state,
                loadingBranchMasterList: true,
                BranchMasterList: [],
                BranchMasterListError: '',
            };
        case 'FIND_BRANCH_MASTER_LIST_SUCCESS':
            return {
                ...state,
                loadingBranchMasterList: false,
                BranchMasterList: action.payload.data,

            };
        case 'FIND_BRANCH_MASTER_LIST_FAILURE':
            return {
                ...state,
                loadingBranchMasterList: false,
                BranchMasterListError: action.payload,
            };
        //Branch Master LiST//
        //Cashbook LiST//
        case 'FIND_CASH_BOOK_LIST_REQUEST':
            return {
                ...state,
                loadingCashBookList: true,
                CashBookList: [],
                CashBookListError: '',
            };
        case 'FIND_CASH_BOOK_LIST_SUCCESS':
            return {
                ...state,
                loadingCashBookList: false,
                CashBookList: action.payload.data,

            };
        case 'FIND_CASH_BOOK_LIST_FAILURE':
            return {
                ...state,
                loadingCashBookList: false,
                CashBookListError: action.payload,
            };
        //Cashbook LiST//
        //Cost Center LiST//
        case 'FIND_COST_CENTER_LIST_REQUEST':
            return {
                ...state,
                loadingCostCenterList: true,
                CostCenterList: [],
                CostCenterListError: '',
            };
        case 'FIND_COST_CENTER_LIST_SUCCESS':
            return {
                ...state,
                loadingCostCenterList: false,
                CostCenterList: action.payload.data,

            };
        case 'FIND_COST_CENTER_LIST_FAILURE':
            return {
                ...state,
                loadingCostCenterList: false,
                CostCenterListError: action.payload,
            };
        //Cost Center LiST//
        //Committed bank LiST//
        case 'FIND_COMMITTED_BANK_LIST_REQUEST':
            return {
                ...state,
                loadingCommittedBankList: true,
                CommittedBankList: [],
                CommittedBankListError: '',
            };
        case 'FIND_COMMITTED_BANK_LIST_SUCCESS':
            return {
                ...state,
                loadingCommittedBankList: false,
                CommittedBankList: action.payload.data,

            };
        case 'FIND_COMMITTED_BANK_LIST_FAILURE':
            return {
                ...state,
                loadingCommittedBankList: false,
                CommittedBankListError: action.payload,
            };
        //Committed bank LiST//

         //ReceiptVoucher List//
        case 'FIND_RECEIPT_VOUCHER_LIST_REQUEST':
            return {
                ...state,
                loadingReceiptVoucherList: true,
                ReceiptVoucherList: [],
                ReceiptVoucherListError: '',
                ReceiptVoucherListCurrentPage: 0,
                ReceiptVoucherListTotalPage: 0,
                ReceiptVoucherListTotalData: 0,
            };
        case 'FIND_RECEIPT_VOUCHER_LIST_SUCCESS':
            return {
                ...state,
                loadingReceiptVoucherList: false,
                ReceiptVoucherList: action.payload.data,
                ReceiptVoucherListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                ReceiptVoucherListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                ReceiptVoucherListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_RECEIPT_VOUCHER_LIST_FAILURE':
            return {
                ...state,
                loadingReceiptVoucherList: false,
                ReceiptVoucherListError: action.payload,
                ReceiptVoucherListCurrentPage: 1,
                ReceiptVoucherListTotalPage: 0,
                ReceiptVoucherListTotalData: 0,
            };
        //ReceiptVoucher List//


        default:
            return state;
    }
}

export default ReceiptVoucherReducer;